import { vaultRequest } from './request';

const ACCOUNT_STATUS_QUERY = `
    query AccountStatus(
        $provider: VaultFinancialProvider!,
        $accountId: ID
    ) {
        vaultAccountStatus(
            provider: $provider,
            accountId: $accountId
        ) {
            valid
            kybRequirements {
                missingFields
                requiredDocuments
            }
            accountRepresentativeRequirements {
                missingFields
                requiredDocuments
            }
            beneficialOwnersRequirements {
                missingFields
                requiredDocuments
            }
        }
    }
`;

export interface VaultEntityStatus {
  missingFields: string[];
  requiredDocuments: VaultRequiredDocument[];
}

export interface VaultAccountStatus {
  valid: boolean;
  kybRequirements?: VaultEntityStatus;
  accountRepresentativeRequirements?: VaultEntityStatus;
  beneficialOwnersRequirements?: VaultEntityStatus[];
}

export const getAccountStatus = async (
  provider: VaultProvider,
  accountId: string | undefined,
  applicationId: string | undefined,
): Promise<VaultAccountStatus> => {
  const accountStatusRes = await vaultRequest(ACCOUNT_STATUS_QUERY, {
    accountId: accountId || null,
    applicationId: applicationId || null,
    provider,
  });
  const accountStatusData = await accountStatusRes.json();
  if (accountStatusData.errors) {
    throw new Error(
      `Could not get account status for ${provider} ${
        accountId || applicationId
      } ${accountStatusData.errors}`,
    );
  }
  return accountStatusData.data.vaultAccountStatus;
};
